import { render, staticRenderFns } from "./PropostasFianca.vue?vue&type=template&id=7f948f9d&scoped=true"
import script from "./PropostasFianca.vue?vue&type=script&lang=js"
export * from "./PropostasFianca.vue?vue&type=script&lang=js"
import style0 from "./PropostasFianca.vue?vue&type=style&index=0&id=7f948f9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f948f9d",
  null
  
)

export default component.exports